import React from 'react';
import { Stack, Text, Divider } from '@moda/om';
import { AuthAction } from '../../lib/authenticate';
import { SocialAuthButtons } from './SocialAuthButtons';

export const CheckoutSocialAuthButtons: React.FC = () => (
  <Stack space={4}>
    <Divider text="OR" treatment="body1" family="sans" />
    <Stack space={3} alignItems="center">
      <Text>Skip the forms and use your saved information.</Text>
      <SocialAuthButtons action={AuthAction.SignIn} />
    </Stack>
  </Stack>
);
